import { formatNumberDisplayValue, maxDecimalValue } from '@/utils/numberUtil';
import { Translations } from '@/utils/translations/Translations';
export const portugueseTranslations: Translations = {
  admin: {
    applicationCyclesCurrent: 'Ciclos de candidatura atuais',
    applicationCyclesHeader: 'Ciclos de candidatura',
    applicationCyclesPast: 'Ciclos de candidatura anteriores',
    applicationCyclesUpcoming: 'Próximos ciclos de candidatura',
    applicationsHeader: 'Candidaturas',
    emailsHeader: 'E-mails',
    tabEmailActivity: 'Atividade de e-mail',
    tabSendEmail: 'Enviar e-mail',
    tabTcowMassApproval: 'Aprovação em massa TCOW',
  },
  address: {
    addAddress2: '+ Apto/Suite/Unidade',
    labelCity: 'Cidade',
    labelCountry: 'País',
    labelCounty: 'Condado',
    labelState: 'Estado',
    labelStreetAddress: 'Endereço',
    labelStreetAddress2: 'Apto/Suite/Unidade',
    labelZipCode: 'CEP',
  },
  applicationBody: {
    approveApplicationButton: 'Aprovar pedido',
    resubmitButton: 'Reenviar',
    sendBackToApplicantWithComments: 'Devolver o pedido ao solicitante com comentários',
    starApprovalButton: 'Aprovar estrela',
    starRemovalButton: 'Remover estrela',
    submitButton: 'Enviar',
    submitMessage: 'Enviando...',
    tooltipApproveSendsToNextReviewStage:
      'Ao clicar em "Aprovar", o pedido é enviado para a próxima etapa de revisão.',
    tooltipApproveBeforeSubmit:
      'Certifique-se de que sua revisão esteja concluída antes de clicar em "Aprovar".',
    tooltipApproveWithUnresolvedComments:
      'Resolva todos os comentários antes de aprovar o pedido. Comentários não resolvidos podem ser encontrados nos padrões destacados em amarelo na barra de progresso.',
    tooltipNextStandard: 'Próximo Padrão',
    tooltipPreviousStandard: 'Padrão Anterior',
    tooltipRequiredQuestions: 'Por favor, responda todas as perguntas obrigatórias primeiro',
    tooltipSendBackRequiresComment:
      'Insira um comentário para esta etapa de revisão antes de devolver o pedido ao solicitante.',
  },
  applicationHeader: {
    headerViewingApplication: 'Vendo aplicativo para ',
    messageRequiredQuestions: 'Por favor, responda a todas as perguntas obrigatórias',
    missingRequiredQuestions: 'Perguntas obrigatórias ausentes',
    reviewerComments: 'Comentários do Revisor',
    standardCompleted: 'Completado',
    starAwarded: 'Estrela concedida',
    yearsRecognized: (year: number) => `Candidatura para o ano ${year} de reconhecimento`,
  },
  applicationPreview: {
    backToAdmin: 'Voltar para Admin',
    previewModeMessage:
      'O modo de visualização está ativado. As alterações nesta página não são salvas.',
    programLabel: 'Programa',
    unknownValue: 'Desconhecido',
  },
  common: {
    ariaSaved: 'Salvo',
    ariaSaveFailed: 'Falha ao salvar',
    ariaSaving: 'Salvando',
    buttonPost: 'Publicar',
    buttonReactivate: 'Reativar',
    buttonResolve: 'Resolver',
    defaultConfirmationModalText: {
      header: 'Confirmar ação',
      confirmationMessage: 'Tem certeza de que deseja executar esta ação?',
      cancelButtonText: 'Cancelar',
      confirmationButtonText: 'Confirmar',
      successMessage: 'Exclusão realizada com sucesso!',
    },
    buttonSaving: 'Salvando...',
    buttonSave: 'Salvar',
    buttonDelete: 'Excluir',
    buttonUpdate: 'Atualizar',
    characterCountRemaining: (remaining: number, max: number) =>
      `${remaining}/${max} caracteres restantes`,
    commentResolved: 'Comentário resolvido',
    error: 'Erro',
    genericError: 'Ocorreu um erro. Por favor, tente novamente.',
    messageCommentAddedSuccessfully: 'Comentário adicionado com sucesso!',
    messageCommentAddFailed: 'Falha ao adicionar comentário',
    messageCommentCannotBeEmpty: 'O comentário não pode estar vazio!',
    messageCommentTooLong: 'O comentário é muito longo!',
    messageGrowthAwardApprovalSuccess: 'Aprovação concluída com sucesso!',
    messageGrowthAwardApproveProblem:
      'Houve um problema ao aprovar o Growth Award. Tente novamente mais tarde.',
    messageGrowthAwardApproving: 'Aprovando Growth Award ...',
    messageGrowthAwardCategoriesFetchError: 'Erro ao buscar categorias do Growth Award.',
    messageGrowthAwardCommentRequired:
      'Insira um comentário antes de devolver o pedido ao solicitante.',
    messageGrowthAwardReturnSuccess: 'Retorno concluído com sucesso!',
    messageGrowthAwardSendBackProblem: 'Houve um problema ao devolver o pedido.',
    messageGrowthAwardSendingBack: 'Enviando Growth Award de volta ao solicitante...',
    messageGrowthAwardSubmitted: 'Aplicação de Growth Award enviada!',
    messageGrowthAwardSubmitting: 'Enviando Growth Award ...',
    messageGrowthAwardSubmitProblem: 'Houve um problema ao enviar o Growth Award.',
    noMatch: 'Nenhum resultado encontrado.',
    placeholderPostComment: 'Publicar um comentário',
    previewInputPlaceholder: 'Entrada de pré-visualização (não salva)',
    previewWorkflowSpecificDataNotice:
      'Esta pergunta usa dados específicos do fluxo de trabalho em produção. O modo de pré-visualização captura apenas texto local e não chama APIs.',
    buttonContinue: 'Continuar',
    buttonCancel: 'Cancelar',
    buttonClose: 'Fechar',
    requiredIndicatorTitle: 'obrigatório',
    statusApplicationApproved: 'Pedido aprovado',
    statusApplicationReturned: 'Pedido devolvido',
    statusApplicationSubmitted: 'Pedido enviado',
    statusApproving: 'Aprovando...',
    statusReturning: 'Devolvendo...',
    statusUpdating: 'Atualizando ...',
    tooltipSubmitGrowthAward: 'Clique para enviar a aplicação de Growth Award.',
    tooltipRetrySave: 'Tentar salvar novamente',
    tooltipSaveFailed: 'Falha ao salvar',
  },
  contact: {
    confirmationModal: {
      header: 'Remover contato',
      confirmationMessage:
        'Tem certeza de que deseja remover este contato? Esta ação não pode ser desfeita.',
      confirmationButtonText: 'Remover contato',
      successMessage: 'Contato removido com sucesso!',
    },
    buttonAdd: 'Adicionar novo contato',
    buttonChange: 'Alterar contato',
    buttonCreate: 'Selecione ou crie um novo contato',
    editContact: 'Editar Contato',
    buttonSave: 'Salvar contato',
    buttonUpdate: 'Atualizar contato',
    createContact: 'Criar novo contato',
    editWarning: (appYear: string) =>
      `Você está prestes a modificar os detalhes de um contato existente. Essas alterações serão atualizadas em todos os lugares onde esse contato é usado nas aplicações de ${appYear}.`,
    invalidEmail: 'Por favor, insira um endereço de e-mail válido.',
    invalidZipCode: 'Por favor, insira um código postal válido.',
    invalidPhoneNumber: 'Número de telefone inválido',
    requiredFieldSuffix: 'é obrigatório',
    labelCity: 'Cidade',
    labelCountry: 'País',
    labelEmail: 'Endereço de e-mail',
    labelFirstName: 'Nome',
    labelLastNameLabel: 'Sobrenome',
    labelName: 'Nome',
    labelPhoneNumber: 'Número de telefone',
    labelStreetAddress2Label: 'Endereço Linha 2',
    labelStreetAddressLabel: 'Endereço Linha 1',
    labelTitle: 'Título profissional',
    labelWhatsApp: 'WhatsApp ou outro número de celular',
    labelZipCode: 'Código postal',
    messageContactRemoved: 'Contato removido!',
    messageContactSaveFailed: 'Não foi possível salvar o contato.',
    messageMaximum: 'Você atingiu o número máximo de contatos para esta seção.',
    messageSaved: 'Contato salvo!',
    placeHolderPhoneNumber: 'Número de telefone',
  },
  dashboard: {
    accessToolkit: 'Acessar kit de ferramentas',
    accessToolkitPendingApproval: 'Disponivel assim que sua inscrição for aprovada',
    download: 'Baixar',
    downloadTooltip: 'Baixar e imprimir pedido',
    fieldApplication: 'Pedido',
    fieldApplicationCycle: 'Ciclo de Pedido',
    fieldStatus: 'Status',
    fieldSubmittedBy: 'Enviado por',
    growthAwardCardHeader: 'CANDIDATAR-SE AO PREMIO DE CRESCIMENTO',
    growthAwardCardPendingLabel: (programName: string) =>
      `A candidatura ao Premio de Crescimento pode ser iniciada depois que sua candidatura ${programName} for enviada.`,
    growthAwardCardStartButton: 'Iniciar Premio de Crescimento',
    labelApplication: 'PEDIDO',
    labelCreateApplication: 'Criar novo pedido',
    labelPastApplications: 'Pedidos',
    messageCreateApplication: 'Criando um novo pedido ...',
    messageNoApplications: 'Nenhuma candidatura',
    portalClosedInformation: (latestAppCycleYear: string, nextOpenDate?: string | null) =>
      `A inscrição para o ciclo ${
        latestAppCycleYear != null ? latestAppCycleYear + ' ' : ''
      }está atualmente fechada. ${
        nextOpenDate != null ? `As inscrições abrirão em ${nextOpenDate}. ` : ''
      }Obrigado.`,
    selectPartner: 'Selecione um parceiro',
    stateQuestionsCardHeader: 'SEU ESTADO SOLICITA INFORMACOES ADICIONAIS',
    stateQuestionsCardPendingLabel:
      'As Perguntas Especificas do Estado podem ser iniciadas depois que uma candidatura Tree City USA for enviada.',
    stateQuestionsCardStartButton: 'Iniciar perguntas de estado',
    viewApplication: 'Ver pedido',
    viewApplicationHelperTextEnabled: 'Ver pedido',
    viewApplicationHelperTextDisabled: 'Pedido não disponível',
    viewApplicationButton: 'Ver pedido',
    growthAwardHeader: 'Prêmio de crescimento',
    growthAwardPendingLabel: 'Prêmio de crescimento pendente',
    growthAwardStartButton: 'Iniciar Prêmio de Crescimento',
    stateQuestionsHeader: 'Perguntas de estado',
    stateQuestionsPendingLabel: 'Perguntas de estado pendentes',
    stateQuestionsStartButton: 'Iniciar perguntas de estado',
    exportEmailLabel: 'Digite seu e-mail para receber um link para download',
    exportEmailAlreadyAdded: (email: string) =>
      `'${email}' já foi adicionado à lista de destinatários da exportação.`,
    exportEmailPlaceholder: 'Endereço de e-mail',
    exportErrorMessage: 'Ocorreu um erro ao gerar o arquivo. Por favor, tente novamente.',
    exportGenerating: 'Gerando arquivo...',
    exportGenerateCsv: 'Gerar CSV',
    exportIncludeQuestionResponses: 'Incluir respostas às perguntas',
    exportInvalidEmailAddress: (email: string) => `'${email}' não é um endereço de e-mail válido.`,
    exportMaxEmailsWarning:
      'Limite máximo de e-mails atingido. Por favor, tente novamente mais tarde.',
    exportModalTitle: 'Exportar dados do aplicativo',
    exportOptionalParams: 'Parâmetros opcionais',
    exportRequiredParams: 'Parâmetros obrigatórios',
    exportSelectApplicationType: 'Selecione o tipo de aplicativo',
    exportSelectCounty: 'Selecione o condado',
    exportSelectPartner: 'Selecione o parceiro',
    exportSelectProgram: 'Selecione o programa',
    exportSelectState: 'Selecione o estado',
    exportSuccessMessage:
      'Arquivo gerado com sucesso! Verifique seu e-mail para o link de download.',
    exportTypeGrowthAward: 'Prêmio de crescimento',
    exportTypeMainApplications: 'Pedidos principais',
    exportTypeStateQuestions: 'Perguntas de estado',
    loadingText: 'Carregando...',
    messageCreateApplicationError: 'Ocorreu um erro ao criar o pedido. Por favor, tente novamente.',
    messageNoCycleFound:
      'Nenhum ciclo de pedido encontrado. Por favor, tente novamente mais tarde.',
    messageFetchApplicationsError:
      'Não foi possível carregar os pedidos. Por favor, tente novamente ou atualize a página.',
  },
  dataUpload: {
    confirmationModal: {
      header: 'Excluir anexo',
      confirmationMessage:
        'Tem certeza de que deseja excluir este anexo? Esta ação não pode ser desfeita.',
      confirmationButtonText: 'Excluir anexo',
      successMessage: 'Anexo excluído com sucesso!',
    },
    errorURL: 'Por favor, envie um URL válido',
    helperSelectFile:
      'Clique em Selecionar para procurar e escolher um arquivo em seu computador. Clique em Salvar para anexá-lo ao seu aplicativo. Certifique-se de que o nome do seu arquivo seja exclusivo. Formatos de arquivo compactados, por ex. .zip, não são suportados.',
    helperUrl:
      'Forneça apenas links para páginas da web públicas e não para uma plataforma de compartilhamento de documentos (por exemplo, Google Docs ou Dropbox). Se for um URL, certifique-se de incluir http:// ou https:// como parte do URL. Clique em Salvar para anexá-lo ao seu aplicativo.',
    labelAddFile: 'Adicionar ficheiro',
    labelEventProof: 'Anexar comprovante do ',
    labelFile: 'Ficheiro',
    labelURL: 'URL',
    labelSave: 'Salvar',
    labelSaving: 'Salvando',
    labelSelectFile: 'Selecione',
    labelUpload: 'Enviando',
    messageDownload: 'Clique para Baixar PDF',
    messageFailed: 'Falha ao carregar.',
    messageSuccess: 'Carregar com sucesso!',
    placeholderURL: 'Digite um URL',
    errorFileSize: 'O tamanho do arquivo excede o limite de 25MB.',
    errorFileTypeUnsupported:
      'Este tipo de arquivo não é suportado. Envie um arquivo diferente de .zip.',
    warningDuplicateFileSkipped:
      'Nome de arquivo duplicado detectado. Arquivos duplicados foram ignorados.',
    warningDuplicateUrlExists: 'Esta URL já foi adicionada.',
    labelTryAgain: 'Tentar novamente',
    labelUploadedFile: 'Arquivo carregado',
    labelSavedUrl: 'URL salva',
    labelGetPdfSummary: 'Obter resumo em PDF',
    tooltipClearError: 'Limpar erro',
    tooltipOpen: 'Abrir',
    tooltipDownload: 'Baixar',
    tooltipDelete: 'Excluir',
    ariaClearUploadError: 'Limpar erro de upload',
    ariaOpenAttachment: 'Abrir anexo',
    ariaOpenUrlAttachment: 'Abrir URL anexada',
    ariaDownloadAttachment: 'Baixar anexo',
  },
  deadlineBanner: {
    deadlineText: 'PRAZO DE PEDIDO',
    stateReviewDeadlineText: 'Prazo de revisao estadual',
  },
  decimalQuestion: {
    maxValueExceeded: `Sua entrada deve ser um número entre 0 e ${formatNumberDisplayValue(
      maxDecimalValue.toString(),
      '.'
    )}.`,
  },
  event: {
    confirmationModal: {
      header: 'Excluir contato',
      confirmationMessage:
        'Tem certeza de que deseja excluir este contato? Esta ação não pode ser desfeita.',
      confirmationButtonText: 'Excluir contato',
      successMessage: 'Evento excluído com sucesso!',
    },
    buttonAddEvent: 'Adicionar',
    celebration: 'Celebração',
    dateRangeError: 'Selecione uma data entre {{minDate}} e {{maxDate}}.',
    eventName: 'Nome do evento',
    helperEvent:
      'Para adicionar outro evento, clique no botão Adicionar abaixo. Para remover um evento adicional, clique no botão excluir no evento (você deve ter pelo menos um evento).',
    labelName: 'Quando sua cidade comemorou as árvores e florestas da cidade durante o ano?',
    labelSubType: 'Tipo de evento',
    labelSubTypeOther: 'Descreva seu evento',
    messageDelete: 'Excluindo...',
    messageSaved: 'Evento salvo!',
    other: 'Outro',
    summary: 'Resuma o',
    tooltipDelete: 'Clique para remover este evento.',
    treeDay: 'Dia da árvore',
    type: 'Tipo',
  },
  header: {
    application: 'PEDIDO',
    dashboard: 'PAINEL',
    error: 'Erro',
    inactive: 'Usuário inativo',
    myaccount: 'Informações da Conta',
    mycontact: 'Informações de Contato',
    pending: 'PENDENTE',
    pendingMessage:
      'Sua conta está aguardando validação. Você poderá prosseguir assim que um administrador aprovar sua solicitação.',
    signedInAs: 'Assinado como',
    signup: 'INSCREVER-SE',
    tooltipDashboard: 'Voltar ao Painel',
    tooltipLanguage: 'Mudar idioma',
    tooltipHelp: 'Ajuda',
    tooltipMyAccount: 'Minha conta',
    tooltipSignOut: 'Sair',
    tooltipUserManagement: 'Gerenciamento de usuários',
    usermanagement: 'GERENCIAMENTO DE USUÁRIOS',
    instructionsTitle: 'Instruções',
    growthaward: 'PRÊMIO DE CRESCIMENTO',
    statequestions: 'PERGUNTAS DE ESTADO',
    tooltipStopImpersonation: 'Parar de personificar',
  },
  integerQuestion: {
    invalidInteger: 'Sua entrada deve estar entre 0 e 99.999.999.',
    labelSum: 'A soma de mudas e mudas deve ser menor ou igual ao total de árvores plantadas.',
  },
  multiCheckbox: {
    helper: 'Selecione pelo menos um',
  },
  multiCheckbox3: {
    helperMaximum: 'Não mais que 3 opções',
  },
  myaccount: {
    accountSettings: 'Configurações da conta',
    characterlimit: (charLimit: number) => `Limite de ${charLimit} caracteres`,
    errorHelperText: 'Preencha todos os campos obrigatórios',
    emailNewAccountHelperText:
      'Para cadastrar um novo endereço de e-mail, você precisará criar uma nova conta.',
    myAccount: 'Minha conta',
    partnerDetails: (partnerName: string) => `Detalhes de ${partnerName}`,
    preferredlanguage: 'Qual é o seu idioma preferido?',
    primaryContactHeader: 'Informações de contato principal',
    titlerequired: 'Título obrigatório',
    updatePrimaryContactError: 'Erro ao atualizar o contato principal',
    updatePrimaryContactSuccess: 'Contato principal atualizado',
    updateUserContactSuccess: 'Contato de usuário atualizado',
    updateUserContactError: 'Erro ao atualizar o contato de usuário',
    unsavedChangesBody: 'Você tem alterações não salvas. Deseja descartá-las e navegar para longe?',
    unsavedChangesTitle: 'Alterações não salvas',
    buttonKeepEditing: 'Continuar editando',
    buttonDiscardChanges: 'Descartar alterações',
    shippingContactHeader: 'Informações de contato de envio',
    tabAccountSettings: 'Configurações da conta',
    tabPrimaryContact: 'Contato principal',
    tabShippingAddress: 'Endereço de envio',
    errorUpdatingShippingContact: 'Erro ao atualizar o contato de envio',
    shippingContactUpdated: 'Contato de envio atualizado',
  },
  partner: {
    other: 'Outro',
  },
  partnerUpdateModal: {
    saveAwards: 'Salvar prêmios',
    saveContacts: 'Salvar contatos',
    savePartnerInfo: 'Salvar informações do parceiro',
    tabContacts: 'Contatos',
    tabPartnerInfo: 'Informações do parceiro',
    tabYearsAwarded: 'Anos premiados',
    titleEditPartnerDetails: 'Editar detalhes do parceiro',
    tooltipError: 'Erro',
    tooltipHasUnsavedChanges: 'Há alterações não salvas',
    tooltipSaved: 'Salvo',
    tooltipSaving: 'Salvando',
  },
  profileMenu: {
    addAccount: 'Adicionar conta',
    addAccountTooltip:
      'Isto é para organizações que participam de vários programas ou têm vários locais e precisam criar contas separadas para cada um.',
    manageAccount: 'Gerenciar conta',
    myAccount: 'Minha conta',
    signOut: 'Sair',
    admin: 'Administração',
    userManagement: 'Gerenciamento de usuários',
  },
  percentQuestion: {
    invalidPercent: 'Sua entrada deve ser um número entre 0 e 100.',
  },
  signature: {
    buttonClear: 'Limpar',
    messageSaved: 'Assinatura salva!',
    terms: 'Termos e Condições',
    tooShortError: 'A assinatura é muito curta. Por favor, desenhe uma assinatura mais longa.',
  },
  submitConfirmation: {
    title: 'Inscrição enviada',
    message: 'Obrigado! Sua inscrição foi enviada e agora está pendente de revisão.',
    reviewApplication: 'Revisar inscrição',
    backToDashboard: 'Voltar ao painel',
  },
  signup: {
    buttonSubmit: 'ENVIAR',
    checkContactShipping: 'Igual ao endereço de contato principal',
    checkIncludeInDirectory:
      'Se minha inscrição for aprovada, NÃO desejo que meu nome e e-mail sejam incluídos no diretório de recursos de membros do Tree Cities of the World (disponível apenas para outras comunidades reconhecidas do Tree Cities of the World).',
    choiceNo: 'Não',
    choiceSelect: 'Selecione',
    choiceYes: 'Sim',
    countrySelect: 'Selecione sua País',
    fuzzyMatchContinue: (partnerTerm: string) => `Continuar criando um novo ${partnerTerm}`,
    fuzzyMatchMessage:
      'Encontramos alguns parceiros existentes com nomes semelhantes no seu estado. Você quis dizer um destes?',
    fuzzyMatchSelect: 'Selecionar',
    fuzzyMatchTitle: 'Parceiros semelhantes encontrados',
    errorMessageEnd: 'Verifique os valores e digite novamente se necessário.',
    errorMessageStart:
      'Houve um problema com seu formulário. As seguintes perguntas não têm um valor válido:',
    errorPartnerHeader: 'Detalhes da Cidade',
    errorPrimaryContactHeader: 'Detalhes do contato principal',
    errorShippingContactHeader: 'Detalhes de envio',
    headerAddAccount: 'Adicionar conta',
    headerExistingPartnerDetails: 'Selecione sua cidade',
    headerLabel: 'Informação',
    headerPartnerDetails: 'Detalhes da Nova Cidade',
    headerPrimaryContact: 'Informações de contato principal',
    headerProgram: 'Portal de Reconhecimento de Programas',
    headerSelectProgram: 'O que você está se candidatando?',
    headerShipping: 'Endereço de envio padrão',
    headerSocialMedia: 'Canais de mídia social para você ',
    helperCityError: 'Cidade necessária',
    helperEmailError: 'Endereço de e-mail obrigatório',
    helperNameError: 'Nome obrigatório',
    helperShippingCityError: 'Cidade necessária',
    helperShippingStreetAddressError: 'Endereço obrigatório',
    helperShippingZipCodeError: 'Insira um código postal de envio válido',
    helperStreetAddressError: 'Endereço obrigatório',
    helperZipCode: 'Insira valores numéricos',
    helperZipCodeError: 'Código postal necessário',
    labelAppliedToADF: (partnerTerm: string, programName: string) =>
      `Não encontrou sua ${partnerTerm} ou é a primeira vez que sua ${partnerTerm} se inscreve para o reconhecimento ${programName}. Clique para iniciar uma nova ${partnerTerm}.`,
    labelCategory: 'Qual categoria melhor descreve sua ',
    labelCity: 'Cidade',
    labelGenericEmail:
      'Endereço de e-mail genérico para governo municipal (exemplo: silvicultor@nomedacidade.com)',
    labelName: 'Nome',
    labelPhoneNumber: 'Número de telefone da ',
    labelShippingCity: 'Cidade',
    labelShippingCountry: 'País',
    labelShippingStreetAddress: 'Endereço Linha 1',
    labelShippingStreetAddress2: 'Endereço Linha 2',
    labelShippingZipCode: 'Código postal',
    labelSubCategoryOther: 'Por favor especifique:',
    labelTitle: 'Título profissional',
    labelZipCode: 'Código postal',
    messageSubmissionError: 'Erro ao enviar o formulário de admissão.',
    messageSubmissionSuccess: 'Formulário de admissão enviado com sucesso.',
    partnerNotFoundHelperText: (partnerTerm: string) =>
      `Nenhum ${partnerTerm} encontrado - Marque a caixa abaixo para iniciar um novo ${partnerTerm}`,
    partnerSelect: 'Selecione sua ',
    required: 'número necessário',
    selectProgram: 'Selecione o programa',
    subHeaderExistingPartnerDetails: (partnerTerm: string, programName: string) =>
      `Se sua ${partnerTerm} já solicitou o reconhecimento ${programName} no passado, pesquise sua ${partnerTerm} usando este formulário. Se não for encontrado, clique na caixa de seleção abaixo para iniciar uma nova ${partnerTerm}.`,
    subHeaderPartnerDetails:
      'Observação: se você estiver se inscrevendo para vários locais, preencha o formulário abaixo para um local. Você terá a oportunidade de adicionar locais adicionais posteriormente no processo.',
    tooltipSubmit: 'Clique para enviar o formulário de admissão.',
  },
  userLoadError: {
    contactUs: 'Fale conosco',
    message:
      'Tente novamente. Se isso continuar acontecendo, entre em contato conosco e informe a referência abaixo.',
    referenceLabel: 'Referência',
    signOut: 'Sair',
    title: 'Não foi possível carregar sua conta.',
    tryAgain: 'Tentar novamente',
  },
  userManagement: {
    removeReviewerAssignmentConfirmationModal: {
      header: 'Excluir atribuição de revisor',
      confirmationMessage:
        'Tem certeza de que deseja remover esta atribuição de revisor? Esta ação não pode ser desfeita.',
      confirmationButtonText: 'Remover atribuição',
      successMessage: 'Atribuição de revisor removida com sucesso!',
    },
    snackbarError: 'edição falhou',
    snackbarSuccess: 'atualizado com sucesso',
  },
};
